import angular from 'angular';
import benefitRequestDaysComponent from './benefitRequestDays.component';

let benefitRequestDaysModule = angular.module('benefitRequestDays', [
])

.component('benefitRequestDays', benefitRequestDaysComponent)

.name;

export default benefitRequestDaysModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestDays/benefitRequestDays.js